import React, { useEffect } from 'react';
import RetrieveInvitePopup from './RetrieveInvitePopup';
import RetrieveTradPopup from './RetrieveTradPopup';
import { Link } from 'react-scroll';
import AOS from 'aos';
import 'aos/dist/aos.css';
import './App.css';
// import gift1 from "../src/Gifts/Air-fryer.jpeg";
// import gift2 from "../src/Gifts/Blender.jpeg";
// import gift3 from "../src/Gifts/Cutlery.jpeg";
// import gift4 from "../src/Gifts/Dinnerware.jpeg";
// import gift5 from "../src/Gifts/Food-processor.jpeg";
// import gift6 from "../src/Gifts/Fry-pan.jpeg";
// import gift7 from "../src/Gifts/Gas-cooker.jpeg";
// import gift8 from "../src/Gifts/Microwave.jpeg";
// import gift9 from "../src/Gifts/Pots.jpeg";
// import gift10 from "../src/Gifts/Sandwich-toaster.jpeg";
// import gift11 from "../src/Gifts/Yam-pounder.jpeg";

function App() {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  useEffect(() => {
    const CYCLE_DURATION = 60000; // must match the last image's exit end time in ms (59s + buffer)

    const track = document.querySelector('.gallery-track.reveal');
    if (!track) return;

    const restart = () => {
      const imgs = track.querySelectorAll('img');
      imgs.forEach(img => {
        // Force reflow to restart animations
        img.style.animation = 'none';
        void img.offsetWidth; // trigger reflow
        img.style.animation = '';
      });
    };

    const timer = setInterval(restart, CYCLE_DURATION);
    return () => clearInterval(timer);
  }, []);

  // const gifts = [
  //   { src: gift1, name: "Air Fryer"},
  //   { src: gift2, name: "Blender"},
  //   { src: gift3, name: "Cutlery"},
  //   { src: gift4, name: "Dinnerware"},
  //   { src: gift5, name: "Food Processor"},
  //   { src: gift6, name: "Frying Pans"},
  //   { src: gift7, name: "Gas cooker"},
  //   { src: gift8, name: "Microwave"},
  //   { src: gift9, name: "Pots"},
  //   { src: gift10, name: "Toaster"},
  //   { src: gift11, name: "Yam pounder"},
  // ];

  const [showInvitePopup, setShowInvitePopup] = React.useState(false);
  const [showTradPopup, setShowTradPopup] = React.useState(false);
  const [isMenuOpen, setIsMenuOpen] = React.useState(false);

  return (
    <div className="app">
      <header className="header">
        <div className="header-content">
          <h1 className="logo">Victory & Joel</h1>

          {/* Animated Hamburger Button */}
          <button 
            className={`menu-toggle ${isMenuOpen ? 'open' : ''}`}
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            aria-label="Toggle menu"
          >
            <span className="hamburger-line"></span>
            <span className="hamburger-line"></span>
            <span className="hamburger-line"></span>
          </button>

          <nav>
            <ul className={`nav-list ${isMenuOpen ? "open" : ""}`}>
              <li><Link to="home" smooth={true} duration={500}>Home</Link></li>
              <li><Link to="story" smooth={true} duration={500}>Our Story</Link></li>
              <li><Link to="details" smooth={true} duration={500}>Wedding Details</Link></li>
              <li><Link to="gallery" smooth={true} duration={500}>Gallery</Link></li>
              <li><Link to="rsvp" smooth={true} duration={500}>RSVP</Link></li>
              <li><Link to="wedding-party" smooth={true} duration={500}>Wedding Party</Link></li>
              <li><Link to="gift-registry" smooth={true} duration={500}>Gift Registry</Link></li>
              <li><Link to="qa" smooth={true} duration={500}>Q & A</Link></li>
            </ul>
          </nav>
        </div>
      </header>

      <section id="home" className="section1" data-aos="zoom-in">
        <div className="gallery-grid1">
          <img src= "/images/Main.jpg" alt="Couple"/>
          <img src = "/images/Pre-wedding2.jpg" alt="Couple1"/>
        </div>
      </section>

      <section className="section hero" data-aos="fade-up">
        <div className="hero-content">
          <h2>We’re Getting Married!</h2>
          <p>Victory Nwanua & Joel Ulaa</p>
          <p>3rd July, 2026</p>
          <p> • Abule Egba, Lagos State</p>
        </div>
      </section>

      <section id="story" className="section" data-aos="fade-right">
        <h2>Our Story</h2>
        <p>He remembers how it all began, sitting at the back of a class when she walked in — graceful, striking, impossible to ignore. He introduced himself, then returned to his seat, stealing glances he thought went unnoticed, though she later admitted she always saw him looking. She was quiet, reserved, yet eloquent when she spoke.<br></br>

        He found small moments to walk beside her after class, eventually sitting next to her and discovering her humor—a warmth that drew him in even more. Though she kept personal distance, he quietly knew she was special.<br></br>

        The program ended and we lost touch, until she had a need and reached out. One hangout led to many, and she grew to admire his simplicity and outlook on life. Months later, after careful reflection, she said yes to love. Since then, we’ve grown together—learning how to love and be loved. She said yes again, this time to Happily Ever After.</p>
      </section>

      <section id="details" className="section" data-aos="fade-left">
        <h2>Wedding Details</h2>
        <p><b>Date:</b> 3rd July, 2026</p>
        <p><b>Location:</b> Abule Egba, Lagos State, Nigeria</p>
        <p><b>Reception:</b>Leotori Event Centre, 2 Powerline street, off Beckley estate road, Abule-Taylor, Abule-Egba, Lagos.</p>
        <p><b>Colors of the day:</b> Peach and Powder Blue</p>
        <p><b>Time:</b> 2pm</p>
      </section>

      {/* Gallery Section */}
      <section id="gallery" className="section gallery" data-aos="zoom-in">
        <h2>Gallery</h2>
        <div className="gallery-slider">
          <h3>Pre-Wedding</h3>
          <div className="gallery-track reveal">
            <img src="/images/c1.jpeg" alt="Gallery 1" />
            <img src="/images/c2.jpeg" alt="Gallery 2" />
            <img src="/images/c3.jpeg" alt="Gallery 3" />
            <img src="/images/c4.jpeg" alt="Gallery 4" />
            <img src="/images/c5.jpeg" alt="Gallery 5" />
            <img src="/images/c6.jpeg" alt="Gallery 6" />
            {/* Add as many images as you want */}
            <img src="/images/c7.jpeg" alt="Gallery 1" />
            <img src="/images/c8.jpeg" alt="Gallery 1" />
            <img src="/images/c9.jpeg" alt="Gallery 1" />
            <img src="/images/c10.jpeg" alt="Gallery 1" />
            <img src="/images/c11.jpeg" alt="Gallery 1" />
            <img src="/images/c12.jpeg" alt="Gallery 1" />
          </div>
          <h3>Proposal</h3>
          <div className="gallery-track left">
            <img src="/images/a1.jpeg" alt="Gallery 1" />
            <img src="/images/a2.jpg" alt="Gallery 2" />
            <img src="/images/a3.jpg" alt="Gallery 3" />
            <img src="/images/a4.jpg" alt="Gallery 4" />
            <img src="/images/a5.jpg" alt="Gallery 5" />
            <img src="/images/a6.jpg" alt="Gallery 6" />
            {/* Add as many images as you want */}
            <img src="/images/a7.jpg" alt="Gallery 1" />
          </div>
          <h3>Court wedding</h3>
          <div className="gallery-track right">
            <img src="/images/b1.jpg" alt="Gallery 1" />
            <img src="/images/b2.jpg" alt="Gallery 2" />
            <img src="/images/b3.jpg" alt="Gallery 3" />
            <img src="/images/b4.jpg" alt="Gallery 4" />
            <img src="/images/b5.jpg" alt="Gallery 5" />
            <img src="/images/b6.jpg" alt="Gallery 6" />
            <img src="/images/b7.jpg" alt="Gallery 6" />
            <img src="/images/b8.jpg" alt="Gallery 6" />
            {/* Add as many images as you want */}
          </div>
        </div>
      </section>

      {/* Wedding Resources Section */}
      <section id="rsvp" className="section resources" data-aos="fade-up">
        <h2>Wedding Resources</h2>
        <div className="resources-grid">
          <div className="resource-item" onClick={() => {
            const link = document.createElement("a");
            link.href = "/Wedding-Magazine.pdf";
            link.download = "Wedding-Magazine.pdf";
            link.click();
          }}>
            <img src="/images/Background.jpg" alt="Wedding Magazine" />
            <p>Download Wedding Magazine</p>
          </div>
          <div className="resource-item" onClick={() => setShowInvitePopup(true)}>
            <img src="/images/Background.jpg" alt="Guest Invite" />
            <p>Download Guest's Invite</p>
          </div>
          {/* <div className="resource-item" onClick={() => setShowTradPopup(true)}>
            <img src="/images/Background.jpg" alt="Guest Invite" />
            <p>Download Trad Invite</p>
          </div> */}
        </div>

        {/* Popup for Guest Invite */}
        
        {showInvitePopup && <RetrieveInvitePopup onClose={() => setShowInvitePopup(false)} />}
        {showTradPopup && <RetrieveTradPopup onClose={() => setShowTradPopup(false)} />}
      </section>

      {/* Wedding Party Section */}
      <section id="wedding-party" className="section" data-aos="fade-up">
        <h2>Wedding Party</h2>

        <h3>Bridal Train</h3>
        <div className="party-grid">
          <div className="party-member">
            <img src="/images/Party/Confidence.jpeg" alt="Confidence" />
            <p>Confidence</p>
          </div>
          <div className="party-member">
            <img src="/images/Party/Chioma.jpeg" alt="Chioma" />
            <p>Glory</p>
          </div>
          <div className="party-member">
            <img src="/images/Party/Bolu.jpeg" alt="Bolu" />
            <p>Bolu</p>
          </div>
          <div className="party-member">
            <img src="/images/Party/Naomi.jpeg" alt="Naomi" />
            <p>Naomi</p>
          </div>
          <div className="party-member">
            <img src="/images/Party/Precious.jpeg" alt="Precious" />
            <p>Precious</p>
          </div>
          <div className="party-member">
            <img src="/images/Party/Opeyemi.jpeg" alt="Opeyemi" />
            <p>Opeyemi</p>
          </div>
          <div className="party-member">
            <img src="/images/Party/Kel.jpg" alt="Kel" />
            <p>Kel</p>
          </div>
        </div>

        <h3>Groomsmen</h3>
        <div className="party-grid">
          <div className="party-member">
            <img src="/images/Men/David-U.jpeg" alt="David" />
            <p>David U</p>
          </div>
          {/* <div className="party-member">
            <img src="/images/Men/Daniel.jpeg" alt="Daniel" />
            <p>Daniel</p>
          </div> */}
          <div className="party-member">
            <img src="/images/Men/David-N.jpeg" alt="David" />
            <p>David N</p>
          </div>
          <div className="party-member">
            <img src="/images/Men/Dozie.jpeg" alt="Dozie" />
            <p>Dozie</p>
          </div>
          <div className="party-member">
            <img src="/images/Men/Femi.jpeg" alt="Femi" />
            <p>Femi</p>
          </div>
          <div className="party-member">
            <img src="/images/Men/Babs.jpeg" alt="Babs" />
            <p>Babs</p>
          </div>
          <div className="party-member">
            <img src="/images/Men/Frank.jpeg" alt="Frank" />
            <p>Frank</p>
          </div>
          <div className="party-member">
            <img src="/images/Men/Jermaine.jpeg" alt="Jermaine" />
            <p>Jermaine</p>
          </div>
          <div className="party-member">
            <img src="/images/Men/Lala.jpeg" alt="Lala" />
            <p>Lala</p>
          </div>
        </div>
      </section>

      {/* Gift Registry Section */}
      <section id="gift-registry" className="section" data-aos="fade-up">
        <h2>Gift Registry</h2>
        <p>
          So you don't have to struggle thinking of what to gift us your lovely couple, we have curated a special list of gifts accessible with the button below. We would also appreciate cash gifts using any of the account numbers below.
        </p>
        <h3>
          0250402678 <br/>WEMA <br/>Ulaa Joel
        </h3>
        <p>
          OR
        </p>
        <h3>
          6212954011 <br/>FCMB <br/>Victory Nwanua
        </h3>
        <button
              type="button"
              onClick={() => window.open("https://wshl.st/jovi", "_blank")}
              className="wishlist-btn"
            >
              GIFT IDEAS
        </button>
        {/* <div className="registry-grid">
          {gifts.map((gift, index) => (
            <div key={index} className="registry-item">
              <h4>{gift.name}</h4>
              <img src={gift.src} alt={gift.name} />
            </div>
          ))}
        </div> */}
      </section>

      {/* Q&A Section */}
      <section id="qa" className="section" data-aos="fade-up">
        <h2>Q & A</h2>
        <div className="qa-item">
          <h3>What is the dress code for the wedding?</h3>
          <p>The dress code for our wedding is formal/trad attire in different shades of Peach or Powder Blue. Please refrain from wearing white, as that is reserved for the bride.</p>
        </div>
        <div className="qa-item">
          <h3>Can i bring a plus one?</h3>
          <p>Every event on our wedding day is strictly RSVP only. We will only be able to accommodate those with an invitation. Please do not bring uninvited guests as they will not be admitted into the venue. You can download your invite in the Wedding Resources section.</p>
        </div>
        <div className="qa-item">
          <h3>Is Lagos traffic really bad?</h3>
          <p>Sometimes it is, but if you’re located considerably far from the venue, please give yourself more than enough time to leave your residence and make it to the venue. The doors to the reception will open at 1:30 PM for guests to be seated. The wedding will begin promptly at 2:00 PM.</p>
        </div>
        <div className="qa-item">
          <h3>We love you both, where can we send gifts?</h3>
          <p>Feel free to visit the Registry tab to see our wishlist or make use of the account numbers provided for monetary gifts.</p>
        </div>
        <div className="qa-item">
          <h3>Any good hotel around the venue where i can lodge?</h3>
          <p>Yes there is. You can make reservations at any of the following hotels located close to the venue: Kashvalley Hotel, Soulmate Hotel, 645 Hotel</p>
        </div>
      </section>

      <footer className="footer">
        <h2 className="footer-logo">Victory & Joel</h2>
        <h2 className="footer-date">03.07.26</h2>
      </footer>
    </div>
  );
}

export default App;
